























































import { State, Action, Getter } from 'vuex-class';
import { Component, Vue, Watch, Prop, Emit } from 'vue-property-decorator';
import { ProfileState, User } from '../store/profile/types';
import axios from 'axios';
import store from '../store';
const namespace: string = 'profile';

@Component
export default class ResetPassword extends Vue {
    @Action('resetPassword', { namespace }) public resetPassword: any;
    @Action('setNewPw', { namespace }) public setNewPw: any;

    private showError: boolean = false;
    private email: string = '';
    private formValid = true;
    private errorMessage: string = 'Something went wrong sending email, try again.';

    private showSuccess: boolean = false;
    private successMessage: string = '';

    private resetId: string = '';

    private emailRules = [
        (v: any) => !!v || 'E-mail is required',
        (v: any) => /.+@.+\..+/.test(v) || 'E-mail must be valid',
    ];

    private form2Valid: boolean = true;

    private showError2: boolean = false;
    private errorMessage2: string = 'Something went wrong changing password, try again.';
    private showSuccess2: boolean = false;
    private successMessage2: string = '';

    private password1: string = '';
    private password2: string = '';

    private complete: boolean = false;

    private passwordRules = [
        (v: any) => !!v || 'Password is required',
        (v: any) => (v && v.length >= 8) || 'Password must have 8+ characters',
    ];

    private async doReset() {
        this.showError = false;

        const user = {email: this.email};

        await this.resetPassword(user);

        const state: any = store.state;
        const resetStateFromState = state.profile.reset;

        if (
            resetStateFromState !== undefined
            && resetStateFromState.resetMessage !== undefined
            && resetStateFromState.resetMessage !== ''
        ) {
            this.successMessage = resetStateFromState.resetMessage;
            this.showSuccess = true;
        } else {
            this.errorMessage = resetStateFromState.error;
            this.showError = true;
        }
    }

    private async doSetNewPw() {
        this.showError = false;

        const user = { linkId: this.resetId, password: this.password1, repeatPassword: this.password2 };

        await this.setNewPw(user);

        const state: any = store.state;
        const resetStateFromState = state.profile.reset;

        if (
            resetStateFromState !== undefined
            && resetStateFromState.resetMessage !== undefined
            && resetStateFromState.resetMessage !== ''
            && resetStateFromState.error === false
        ) {
            this.successMessage2 = resetStateFromState.resetMessage;
            this.showSuccess2 = true;

            this.complete = true;
        } else {
            this.errorMessage2 = resetStateFromState.resetMessage;
            this.showError2 = true;
        }
    }

    @Watch('this.$route.name', {immediate: true})
    private setResetId() {
        if (
            this.$route.name === 'ResetPasswordWithId'
            && this.$route.params.resetid !== null
            && this.$route.params.resetid !== ''
        ) {
            this.resetId = this.$route.params.resetid;
        }
    }
}
